import { createHash } from 'node:crypto';
import type { ProvisionInput, ProvisionOutput } from './types.js';
import { getFramework } from './framework-registry.js';

function sha256(content: string): string {
  return createHash('sha256').update(content, 'utf8').digest('hex');
}

/**
 * Orchestrates agent provisioning: delegates to the framework adapter to build
 * artifacts, computes content hashes. Returns a ProvisionOutput describing the
 * artifacts to be written (does NOT write to disk — the CLI handles that).
 */
export function provision(input: ProvisionInput, frameworkId: string = 'claude-code'): ProvisionOutput {
  const adapter = getFramework(frameworkId);
  const artifacts = adapter.buildArtifacts(input);

  const charterHash = sha256(input.charterContent);
  const toolsHash = sha256(input.toolsContent);

  const teamDir = `.augmented/${input.agent.code_name}`;

  return {
    teamDir,
    artifacts,
    charterHash,
    toolsHash,
  };
}
